import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { InterventionPendingChecklist } from "models";

type UseDeletePendingChecklistMutationProps = {
  handleRemoveItem: (id: number) => void;
};

export const useDeletePendingChecklistMutation = ({ handleRemoveItem }: UseDeletePendingChecklistMutationProps) =>
  useTypedMutation({
    mutationFn: (payload: InterventionPendingChecklist) => ApiInstance.post("/interventions/pending_checklists/delete", payload, ENV.appointmentBaseURL),
    onSuccess: payload => {
      handleRemoveItem(payload.checklist_id);

      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment?.interventions) return;

      const interventionIdx = appointment.interventions.findIndex(intervention => intervention.id === payload.intervention_id);
      if (interventionIdx < 0) return;

      const intervention = appointment.interventions[interventionIdx];
      if (!intervention.pending_checklists?.length) return;

      const pendingChecklistIdx = intervention.pending_checklists.findIndex(pc => pc.checklist_id === payload.checklist_id);
      if (pendingChecklistIdx < 0) return;

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, {
        ...appointment,
        interventions: appointment.interventions.with(interventionIdx, {
          ...intervention,
          pending_checklists: intervention.pending_checklists.toSpliced(pendingChecklistIdx, 1).map((checklist, idx) => ({ ...checklist, ordering: idx + 1 }))
        })
      });
    }
  });
